import { useQuery } from '@tanstack/react-query';

import { getOfferingsSearch, OfferingSearchResponse } from '@arrived/api_v2';
import { OfferingSearchQuery } from '@arrived/models';

import { UseQueryOptions } from '../queries.utils';
import { offeringsKeyFn } from './offerings.keys';

export function useOfferingSearchQuery(query?: OfferingSearchQuery, options?: UseQueryOptions<OfferingSearchResponse>) {
  return useQuery(offeringsKeyFn(query), () => getOfferingsSearch(query), {
    staleTime: 30_000,
    keepPreviousData: true,
    ...options,
    onSuccess: (data) => {
      // TODO: re-enable this we can't cache for now because there are certain attributes that are missing on the
      //  offering model return from OpenSearch that we need elsewhere.

      // data.data?.forEach((offering) => {
      //   queryClient.setQueryData(offeringKeyFn(offering.id), offering, { updatedAt: Date.now() });
      //   queryClient.setQueryData(offeringKeyFn(offering.shortName), offering, { updatedAt: Date.now() });
      // });
      options?.onSuccess?.(data);
    },
  });
}
